export default "__VITE_ASSET__BvQj$LQb__"